export default {
  disasterAvoidPolygons: {
    name: 'Nombre',
    description: 'Descripción',
    disasterType: 'Tipo de desastre',
    disasterSubType: 'Subtipo de desastre',
    fillRequiredFields: 'Complete los campos obligatorios para el área del desastre',
    avoidAreaSaved: 'Área de desastre salvada',
    avoidAreaDeleted: 'Área de desastre eliminada',
    fillAreaProperties: 'Rellene las propiedades del área a evitar y guárdelo',
    editProperties: 'Cambiar propiedades',
    createADisasterPolygon: 'Crea un polígono de desastre',
    createADisasterRectangle: 'Crea un rectángulo de desastre',
    errorWhileTryingToSaveDisasterArea: 'Error al intentar salvar el área de desastre',
    authorizationError: 'Error de autorización. Asegúrese de que la clave que ingresó sea válida. Para ingresar la clave nuevamente, recargue la aplicación',
    disasterAreaUsageInfo: 'Puede: mover la vista del mapa para cargar áreas de desastre de una región objetivo, usar las herramientas de dibujo de polígonos para crear nuevas áreas de desastre y hacer clic en un área de desastre para editarla',
    errorCodes: {
      2404: 'El proveedor no existe',
      3404: 'El tipo de desastre no existe',
      5409: 'El nombre del área de desastre ya está en uso'
    },
    statuses: {
      401: 'No autorizado',
    }
  }
}
